/**
 * Created by USER on 18/8/22.
 */
import React, { Component } from 'react';

export default class Thank extends Component {
  constructor(props) {
    super(props);
    this.state = {
      successTxt: '',
      time: 3
    };
  }
  componentDidMount() {
    const b64DecodeUnicode = function (str) {
      return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
    };
    const error = window.location.hash.substr(1);
    console.log(error, 'sssssssss')
    if (error) {
      try {
        const errorTxt = b64DecodeUnicode(error);
        this.setState({
          successTxt
        });
      } catch (err) {}
    }

    let time = 3;
    const countdown = setInterval(() => {
      this.setState({
        time
      });
      if (time === 0) {
        window.open(' ', '_self').close();
        clearInterval(countdown);
      }
      time--;
    }, 1000);
  }

  render() {
    const {successTxt, time} = this.state;
    return (
      <div className="thank_container">
        <div className="thank_img">
          <img src="https://lubansohz.oss-cn-hangzhou.aliyuncs.com/lubanso-web/images/2018-08-22/393bf629d98f430b862f119d2fe818af.png" alt="LUBANSO" />
        </div>
        <div className="thank_success">支付成功</div>
        <div className="thank_notice">{successTxt}</div>
        <div className="thank_notice_two">感谢您对LUBANSO的支持，我们不会以任何理由要求您提供银行卡信息或支付额外费用，请谨慎防钓鱼链接或诈骗电话。</div>
        <div>页面将于&nbsp;<span className="thank_account">{time}</span>&nbsp;秒后关闭</div>
      </div>
    );
  }
}
